import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { updateComopanyImg } from '../../../../Apis/companydata';
import { Company } from '../../../../models/Company';
import {
    companyDataToUpdate,
    updateCompany
} from '../../../../reduxToolkit/UpdateCompany/UpdateCompanyApi';
import { mapCoordinates } from '../../../../reduxToolkit/UpdateCompany/UpdateCompanySlice';
import { getPhotoPicker, PHOTO_PICKER_MODEL } from '../../../../components/PhotoPicker/SubComponent/Models/Models';
import noLogo from '../../../../assets/defaultImages/no-logo.png';

const UpdateDataApp = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    // Redux state
    const { user: { data: { id } } } = useSelector((state) => state.authenticatioauthennSlice);
    const { companyDataToUpdateObj } = useSelector((state) => state.UpdateCompanySlice);
    const { latLngObj } = useSelector((state) => state.UpdateCompanySlice);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);

    // Local state
    const [showMap, setShowMap] = useState(false);
    const [companyData, setCompanyData] = useState({ ...Company });
    const [emptyFields, setEmptyFields] = useState(false);
    const [photoPicker, setPhotoPicker] = useState({ ...PHOTO_PICKER_MODEL, preview: noLogo });
    const [modified, setModified] = useState(0);

    useEffect(() => {
        if (id) {
            dispatch(companyDataToUpdate(id)).then(({ payload }) => {
                const data = payload?.data?.data;
                if (data) {
                    dispatch(
                        mapCoordinates({
                            address: data.address || '',
                            lat: data.latitud || null,
                            lng: data.longitud || null,
                        })
                    );
                }
            });
        }
    }, [id, modified, dispatch]);

    useEffect(() => {
        if (Object.keys(companyDataToUpdateObj).length > 0) {
            const { latitud, longitud, image, ...rest } = companyDataToUpdateObj;

            setCompanyData((prev) => ({
                ...prev,
                ...rest,
            }));

            // Manejo de imagen
            if (image) {
                setPhotoPicker({
                    ...PHOTO_PICKER_MODEL,
                    preview: noLogo,
                    previewImage: `data:;base64,${image}`,
                });
            }
        }
    }, [companyDataToUpdateObj]);

    useEffect(() => {
        if (latLngObj) {
            setCompanyData((prev) => ({
                ...prev,
                address: latLngObj.address || prev.address,
                latitud: latLngObj.lat ?? prev.latitud,
                longitud: latLngObj.lng ?? prev.longitud,
            }));
        }
    }, [latLngObj]);

    // Handlers
    const handleChange = (e) => {
        const { name, value } = e.target;
        setCompanyData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = () => {
        if (!companyData.isValid()) {
            setEmptyFields(true)
            toast.warn(t('please_fill_all_fields').toUpperCase());
        } else {
            let updated = modified;
            dispatch(updateCompany(companyData.toUpdate())).then(({payload: {data: { data }}}) => {
                    dispatch(mapCoordinates(
                        {
                            address: data?.address,
                            lat: data?.latitud,
                            lng: data?.longitud,
                        }),
                    );
                updated ++;
                    const newImageToUpload = getPhotoPicker(photoPicker);
                    if (newImageToUpload && newImageToUpload != null && typeof newImageToUpload != 'undefined') {
                        const formData = new FormData();
                        formData.append('id', data?.id);
                        formData.append('option', 'company');
                        formData.append('file', newImageToUpload);
                        updateComopanyImg(formData).then((data) => {}).catch((error) => {
                            toast.error('something_went_wrong_2');
                        });
                        updated ++;
                        setPhotoPicker({...PHOTO_PICKER_MODEL})
                    }
                setModified( prev => prev + updated) ;
                },
            );
        }
    };

    return {
        companyData,
        DEV,
        handleChange,
        handleSubmit,
        latLngObj,
        permission,
        showMap,
        setShowMap,
        t,
        emptyFields,
        photoPicker,
        setPhotoPicker,
    };
};

export default UpdateDataApp;
